<template>
  <v-text-field
    color="primary"
    :height="36"
    dense
    outlined
    v-bind="{ ...$attrs, ...$props }"
    @input="$emit('input', $event)"
    @blur="$emit('blur', $event)"
    @focus="$emit('focus', $event)"
  >
    <slot />
    <template #append>
      <slot name="append" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'BaseTextfield',
}
</script>
